<div class="p-3">
  <form [formGroup]="studentForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <!-- First Name -->
      <div class="col-md-6 mb-3">
        <label for="firstName" class="form-label">
          {{ 'DATA_TABLE.FIRST_NAME' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" id="firstName" formControlName="firstName"
          [class.is-invalid]="isFieldInvalid('firstName')" [placeholder]="'DATA_TABLE.FIRST_NAME' | translate" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
          {{ getErrorMessage('firstName') }}
        </div>
      </div>

      <!-- Last Name -->
      <div class="col-md-6 mb-3">
        <label for="lastName" class="form-label">
          {{ 'DATA_TABLE.LAST_NAME' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" id="lastName" formControlName="lastName"
          [class.is-invalid]="isFieldInvalid('lastName')" [placeholder]="'DATA_TABLE.LAST_NAME' | translate" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
          {{ getErrorMessage('lastName') }}
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Email -->
      <div class="col-md-6 mb-3">
        <label for="email" class="form-label">
          {{ 'DATA_TABLE.EMAIL' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input type="email" class="form-control" id="email" formControlName="email"
          [class.is-invalid]="isFieldInvalid('email')" [placeholder]="'DATA_TABLE.EMAIL' | translate" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
          {{ getErrorMessage('email') }}
        </div>
      </div>

      <!-- Student Code -->
      <div class="col-md-6 mb-3">
        <label for="studentCode" class="form-label">
          {{ 'DATA_TABLE.STUDENT_CODE' | translate }}
          <span class="text-danger">*</span>
          <span *ngIf="isCheckingCode" class="spinner-border spinner-border-sm ms-2" role="status">
            <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
          </span>
          <span *ngIf="!isCheckingCode && codeAvailable === true" class="text-success ms-2">
            <i class="fa-solid fa-check-circle"></i>
          </span>
          <span *ngIf="!isCheckingCode && codeAvailable === false" class="text-warning ms-2">
            <i class="fa-solid fa-times-circle"></i>
          </span>
        </label>
        <input type="text" class="form-control" id="studentCode" formControlName="studentCode"
          [class.is-invalid]="isFieldInvalid('studentCode')" [placeholder]="'DATA_TABLE.STUDENT_CODE' | translate" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('studentCode')">
          {{ getErrorMessage('studentCode') }}
        </div>
        <small class="form-text text-muted" *ngIf="!isEditMode">
          {{ 'VALIDATION.STUDENT_CODE_HINT' | translate }}
        </small>
      </div>
    </div>

    <div class="row">
      <!-- Learning Path -->
      <div class="col-md-6 mb-3">
        <app-custom-select
          [label]="('DATA_TABLE.LEARNING_PATH' | translate) + ' *'"
          [placeholderText]="'ADMIN.SELECT_PATH' | translate"
          [options]="learningPaths"
          [allowAdd]="false"
          [inputId]="'learningPathId'"
          [showError]="isFieldInvalid('learningPathId')"
          [errorMessage]="getErrorMessage('learningPathId')"
          [labelClass]="'form-label'"
          [triggerClass]="'select-trigger form-control'"
          formControlName="learningPathId">
        </app-custom-select>
      </div>
<div class="col-md-6 mb-3">

<app-custom-select
  *ngIf="selectKey >= 0"
  [attr.data-key]="selectKey"
  [label]="'المواد'"
  [placeholderText]="'ابحث...'"
  [options]="subjectOptions"
  [allowAdd]="false"
  [inputId]="'subjectIds'"
  [multiple]="true"
  [disabled]="isLoadingSubjects"
  [labelClass]="'form-label'"
  [triggerClass]="'select-trigger form-control'"
  formControlName="subjectIds">
</app-custom-select>
</div>
      <!-- Pack : il décide de ce que l'espace élève ouvre. À la création
           seulement — il est alors enregistré comme inscription validée. -->
      @if (!isEditMode) {
        <div class="col-md-6 mb-3">
          <app-custom-select
            [label]="('ADMIN.STUDENT_PACK' | translate) + ' *'"
            [placeholderText]="'ADMIN.SELECT_PACK' | translate"
            [options]="packOptions"
            [allowAdd]="false"
            [inputId]="'packId'"
            [showError]="isFieldInvalid('packId')"
            [errorMessage]="getErrorMessage('packId')"
            [labelClass]="'form-label'"
            [triggerClass]="'select-trigger form-control'"
            formControlName="packId">
          </app-custom-select>
          @if (packsUnavailable) {
            <small class="form-text text-danger">{{ 'ADMIN.PACKS_UNAVAILABLE' | translate }}</small>
          } @else {
            <small class="form-text text-muted">{{ 'ADMIN.STUDENT_PACK_HINT' | translate }}</small>
          }
        </div>

        <!-- Mot de passe initial : proposé, modifiable, temporaire. L'élève en
             choisit un autre à sa première connexion. -->
        <div class="col-md-6 mb-3">
          <label for="password" class="form-label">
            {{ 'ADMIN.INITIAL_PASSWORD' | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="input-group">
            <input type="text" class="form-control" id="password" formControlName="password"
              autocomplete="off" spellcheck="false" dir="ltr"
              [class.is-invalid]="isFieldInvalid('password')" />
            <button type="button" class="btn btn-outline-secondary" (click)="generatePassword()">
              <i class="fa-solid fa-rotate"></i> {{ 'ADMIN.GENERATE_PASSWORD' | translate }}
            </button>
          </div>
          @if (isFieldInvalid('password')) {
            <div class="invalid-feedback d-block">{{ getErrorMessage('password') }}</div>
          }
          <small class="form-text text-muted">{{ 'ADMIN.INITIAL_PASSWORD_HINT' | translate }}</small>
        </div>
      }

      <!-- Enrollment Date -->
      <div class="col-md-6 mb-3">
        <label for="enrollmentDate" class="form-label">
          {{ 'DATA_TABLE.ENROLLMENT_DATE' | translate }}
        </label>
        <input type="date" class="form-control" id="enrollmentDate" formControlName="enrollmentDate"
          [class.is-invalid]="isFieldInvalid('enrollmentDate')" />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('enrollmentDate')">
          {{ getErrorMessage('enrollmentDate') }}
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Is Active -->
      <div class="col-md-12 mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="isActive" formControlName="isActive" />
          <label class="form-check-label" for="isActive">
            {{ (isActive?.value ? 'ADMIN.ACTIVE' : 'ADMIN.INACTIVE') | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- Réinitialiser le mot de passe d'un élève existant : un nouveau mot de
         passe temporaire, qu'il remplacera à sa connexion suivante. -->
    @if (isEditMode && student) {
      <div class="row">
        <div class="col-md-12 mb-3">
          <label for="newPassword" class="form-label">{{ 'ADMIN.RESET_PASSWORD' | translate }}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="newPassword" [(ngModel)]="newPassword"
              [ngModelOptions]="{ standalone: true }" autocomplete="off" spellcheck="false" dir="ltr" />
            <button type="button" class="btn btn-outline-secondary" (click)="generateNewPassword()">
              <i class="fa-solid fa-rotate"></i> {{ 'ADMIN.GENERATE_PASSWORD' | translate }}
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="resetPassword()"
              [disabled]="newPassword.length < 8 || isResettingPassword">
              {{ 'ADMIN.APPLY_PASSWORD' | translate }}
            </button>
          </div>
          <small class="form-text text-muted">{{ 'ADMIN.INITIAL_PASSWORD_HINT' | translate }}</small>
        </div>
      </div>
    }

    <!-- Form Actions -->
    <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
      <button type="button" class="btn btn-secondary px-4" (click)="onCancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn btn-primary px-4"
        [disabled]="saving || studentForm.invalid || isCheckingCode">
        <i class="fa-solid me-2" [class.fa-floppy-disk]="!saving"
           [class.fa-spinner]="saving" [class.fa-spin]="saving"></i>
        {{ (isEditMode ? 'COMMON.UPDATE' : 'COMMON.SAVE') | translate }}
      </button>
    </div>
  </form>
</div>
